// login.component.ts
import { Component, inject, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'login',
  standalone: true,
  template: '<p>Fazendo Login...</p>',
})
export class LoginComponent implements OnInit {
  private authService = inject(MsalService);
  constructor() {}

  ngOnInit() {
  console.log('loginn....');
  const urlParams = new URLSearchParams(window.location.search);
  // const redirectParam = urlParams.get('redirect') || window.location.origin;
  const redirectParam = urlParams.get('returnUrl') || window.location.origin;
  const finalRedirect = `${redirectParam}/home`;
  const state = encodeURIComponent(redirectParam || window.location.origin);

  let autenticado = this.authService.instance.getAllAccounts().length > 0;
  // if(!autenticado){
  //   this.authService.loginRedirect({
  //     scopes: ['https://saguitechb2c.onmicrosoft.com/8be9481b-b76f-457d-aaba-84fc7a4cd91a/PortalPais.Read'],
  //     state: encodeURIComponent(finalRedirect),
  //   });
  // }

  // this.authService.instance.handleRedirectPromise().then((result) => {
  //   console.log(result);

  // })
}
}
